import React from 'react';

const HowItWorks = () => {
  return (
    <section className="primary-bg py-10 md:py-14 lg:py-18">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-6 md:mb-8 lg:mb-10">
          <h2 className="font-bold text-white mb-3 md:mb-4">
            How it <span className="secondary-text">Works</span>
          </h2>
          <p className="  text-white opacity-90 max-w-4xl mx-auto px-4 leading-relaxed">
            AiDA extracts and organizes the data in a way that your organization can derive meaningful insights from the data you always 
            held but was cumbersome to understand. This will help you come to more enlightened Decision making with all your historical 
            data at your fingertips.
          </p>
        </div>

        {/* Workflow Diagram */}
        <div className="flex justify-center items-center">
          <div className="w-full max-w-3xl">
            <img
              src='/assets/aida/worksection.svg'
              alt="How AiDA Works - Client, API, and API Server workflow diagram"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;